import { useEffect, useState } from 'react';
import api from '../api/client';

// Phase F2 — session-cached public app config (people_feed_enabled, ...).
let cache = null;
let promise = null;

export const fetchAppConfig = () => {
  if (cache) return Promise.resolve(cache);
  if (!promise) {
    promise = api
      .get('/public/config')
      .then((r) => { cache = r.data || {}; return cache; })
      .catch(() => { cache = {}; return cache; });
  }
  return promise;
};

export default function useAppConfig() {
  const [config, setConfig] = useState(cache);
  useEffect(() => {
    let on = true;
    fetchAppConfig().then((c) => { if (on) setConfig(c); });
    return () => { on = false; };
  }, []);
  return {
    config: config || {},
    loaded: config !== null,
    peopleFeedEnabled: !!(config && config.people_feed_enabled),
    // Phase F3 — Voice-First video kill-switches
    videoPostsEnabled: !!(config && config.video_posts_enabled),
    videoLiveEnabled: !!(config && config.video_live_enabled),
    videoO2OEnabled: !!(config && config.video_o2o_enabled),
  };
}
